import { useEffect, useRef, useState } from "react";
import { Button } from 'primereact/button';
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from '../../context/AuthContext';
import './SiderBar.module.css';

const menuItems =
  [
    { label: 'Ana Sayfa', icon: 'pi pi-home', link: '/' },
    { label: 'Müşteriler', icon: 'pi pi-users', link: '/customers' },
    {
      label: 'Tedarikçiler', icon: 'pi pi-truck',

      children: [
        { label: 'Tedarikçi Listesi', icon: 'pi pi-list', link: '/suppliers' },
        { label: 'Yeni Tedarikçi', icon: 'pi pi-plus', link: '/suppliers/add' }
      ]
    },
    {
      label: 'Ürünler', icon: 'pi pi-box',
      children: [
        { label: 'Ürün Listesi', icon: 'pi pi-list', link: '/products' },
        { label: 'Yeni Ürün Ekle', icon: 'pi pi-plus', link: '/products/add' },
        { label: 'Fiyat Listesi', icon: 'pi pi-dollar', link: '/products/price-tiers' }
      ]
    },
    {
      label: 'Stok İşlemleri', icon: 'pi pi-database',
      children: [
        { label: 'Stok Hareketleri', icon: 'pi pi-history', link: '/stock/movements' },
        { label: 'Hızlı Stok Giriş/Çıkış', icon: 'pi pi-directions-alt', link: '/stock/adjustment' },
        { label: 'Kritik Stok Takibi', icon: 'pi pi-exclamation-triangle', link: '/stock/critical' },
        { label: 'Depo Listesi', icon: 'pi pi-home', link: '/warehouses' }
      ]
    },
    {
      label: 'Satışlar', icon: 'pi pi-shopping-cart',
      children: [
        { label: 'Yeni Satış', icon: 'pi pi-plus', link: '/sales/productsale' },
        { label: 'Satışların Listesi', icon: 'pi pi-list', link: '/sales' },
        { label: 'Perakende Satış Listesi', icon: 'pi pi-shopping-bag', link: '/sales/retail' },
        { label: 'Tekliflerim', icon: 'pi pi-file-edit', link: '/quotations' },
        { label: 'İade Listesi', icon: 'pi pi-refresh', link: '/returns' }
      ]

    },
    {
      label: 'Giderler', icon: 'pi pi-wallet',
      children: [
        { label: 'Gider Listesi', icon: 'pi pi-list', link: '/expenses' },
        { label: 'Yeni Gider Ekle', icon: 'pi pi-plus', link: '/expenses/add' },
        { label: 'Gider Başlıkları', icon: 'pi pi-tags', link: '/expenses/categories' }
      ]
    },
    {
      label: 'Finans', icon: 'pi pi-percentage', isNew: true,
      children: [
        { label: 'Tahsilat İşlemleri', icon: 'pi pi-money-bill', link: '/finance/collections' },
        { label: 'Müşteri Çekleri', icon: 'pi pi-id-card', link: '/finance/cheques' },
        { label: 'Kendi Çeklerimiz', icon: 'pi pi-credit-card', link: '/finance/own-cheques' },
        { label: 'Müşteri Senetleri', icon: 'pi pi-file', link: '/finance/promissory-notes' },
        { label: 'Kendi Senetlerimiz', icon: 'pi pi-file-edit', link: '/finance/own-promissory-notes' },
        { label: 'Taksit Ödeme Planlarım', icon: 'pi pi-calendar-plus', link: '/finance/installments', isNew: true },
        { label: 'Hesaplarım', icon: 'pi pi-wallet', link: '/finance/accounts' },
        { label: 'Hesap Tanımları', icon: 'pi pi-plus-circle', link: '/finance/accounts/add' }
      ]
    },
    {
      label: 'Çalışanlarım', icon: 'pi pi-id-card',
      children: [
        { label: 'Çalışan Listesi', icon: 'pi pi-list', link: '/employees' },
        { label: 'Yeni Çalışan Ekle', icon: 'pi pi-plus', link: '/employees/add' }
      ]
    },
    {
      label: 'Raporlar', icon: 'pi pi-chart-bar', isNew: true,
      children: [
        { label: 'Satış Raporu', icon: 'pi pi-shopping-cart', link: '/reports/sales' },
        { label: 'Gider Raporu', icon: 'pi pi-wallet', link: '/reports/expenses' },
        { label: 'Kar/Zarar Analizi', icon: 'pi pi-percentage', link: '/reports/profit-loss' },
        { label: 'Stok Raporu', icon: 'pi pi-box', link: '/reports/stock' },
        { label: 'Müşteri Bakiyeleri', icon: 'pi pi-users', link: '/reports/customer-balance' },
        { label: 'Şube Raporu', icon: 'pi pi-map-marker', link: '/reports/branch', isNew: true },
        { label: 'Hesap Hareketleri', icon: 'pi pi-credit-card', link: '/reports/account-transactions', isNew: true }
      ]
    },
    {
      label: 'Ayarlar', icon: 'pi pi-cog ',
      children: [
        { label: 'Kategoriler', icon: 'pi pi-align-justify', link: '/categories' },
        { label: 'Yazdırma Tasarımları', icon: 'pi pi-print', link: '/settings/print-templates' },
        { label: 'Teklif Tasarımı', icon: 'pi pi-file-pdf', link: '/settings/quotation-template' },
        { label: 'Görünüm Ayarları', icon: 'pi pi-sliders-h', link: '/settings/view-settings' },
        { label: 'Şube Yönetimi', icon: 'pi pi-map-marker', link: '/settings/branches' }
      ]
    },

  ];

export default function Sidebar({ visible, isCollapsed, onClose }) {
  const location = useLocation();
  const { user } = useAuth();
  const isSystemAdmin = user?.IsSystemAdmin === "True";
  const isSalesUser = user?.UserRole === "Sales";

  let filteredMenuItems = menuItems;

  if (isSalesUser) {
    filteredMenuItems = menuItems
      .map((item) => {
        // Satış kullanıcısının görebileceği ana menüler
        if (item.label === "Ana Sayfa" || item.label === "Müşteriler" || item.label === "Satışlar") {
          return item;
        }
        // Ürünler menüsünde sadece Ürün Listesi
        if (item.label === "Ürünler") {
          return {
            ...item,
            children: item.children.filter((child) => child.label === "Ürün Listesi"),
          };
        }
        return null;
      })
      .filter(Boolean);
  }

  if (isSystemAdmin) {
    filteredMenuItems = [...filteredMenuItems, { label: 'Sistem Yönetimi', icon: 'pi pi-shield', link: '/admin/panel' }];
  }

  const [openIndex, setOpenIndex] = useState(null);
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [hoverPos, setHoverPos] = useState(0);
  const hoverTimeout = useRef(null);

  const handleMouseEnter = (index, event) => {
    if (!isCollapsed) return;
    if (hoverTimeout.current) clearTimeout(hoverTimeout.current);

    if (event) {
      const rect = event.currentTarget.getBoundingClientRect();
      setHoverPos(rect.top);
    }
    setHoveredIndex(index);
  };

  const handleMouseLeave = () => {
    if (!isCollapsed) return;
    hoverTimeout.current = setTimeout(() => {
      setHoveredIndex(null);
    }, 150);
  };

  useEffect(() => {
    return () => {
      if (hoverTimeout.current) clearTimeout(hoverTimeout.current);
    };
  }, []);

  if (!visible) return null;
  return (
    <aside className={`${isCollapsed ? "w-[80px] overflow-visible" : "w-[260px] overflow-hidden"} transition-all duration-300 h-full bg-[#0f172a] dark:bg-slate-950 text-slate-300 flex flex-col border-r border-slate-800`}>
      {/* LOGO BÖLÜMÜ */}
      <div className={`h-[56px] flex items-center ${isCollapsed ? "justify-center" : "justify-between"} px-5 border-b border-slate-800/50`}>
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-blue-600 min-w-8 rounded-lg flex items-center justify-center shadow-lg shadow-blue-900/20">
            <i className="pi pi-wallet text-white text-lg" />
          </div>
          {!isCollapsed && <span className="font-bold text-xl text-white tracking-tight">KasamBenim</span>}
        </div>
        <Button
          icon="pi pi-times"
          className="p-button-text !text-slate-500 hover:!text-white lg:hidden"
          onClick={onClose}
          aria-label="Kapat"
        />
      </div>

      <div className={`flex-1 ${isCollapsed ? "overflow-visible" : "overflow-y-auto custom-scrollbar"} px-3 py-4`}>
        <nav className="space-y-1 overflow-visible">
          {filteredMenuItems.map((item, i) => {
            const isActive = location.pathname === item.link || (item.children && item.children.some(c => location.pathname === c.link));
            const isOpen = openIndex === i;

            return (
              <div
                key={i}
                className="group relative"
                style={{ zIndex: hoveredIndex === i ? 9999 : 1 }}
                onMouseEnter={(e) => handleMouseEnter(i, e)}
                onMouseLeave={handleMouseLeave}
              >
                {item.children ? (
                  <button
                    className={`w-full flex items-center ${isCollapsed ? "justify-center" : "justify-between"} px-3.5 py-2.5 rounded-xl transition-all duration-200 bg-transparent group-hover:bg-slate-800/50 border-none cursor-pointer ${isActive ? "bg-blue-600/10 text-blue-500 font-semibold" : "text-slate-400 font-medium hover:text-slate-200"
                      }`}
                    onClick={() => !isCollapsed && setOpenIndex(isOpen ? null : i)}
                    title={isCollapsed ? item.label : ""}
                  >
                    <div className="flex items-center gap-2.5">
                      <div className="relative">
                        <i className={`${item.icon} text-lg ${isActive ? "text-blue-500" : "text-slate-500 group-hover:text-slate-300"}`} />
                        {isCollapsed && item.isNew && (
                          <span className="absolute -top-1 -right-1 flex h-2 w-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                          </span>
                        )}
                      </div>
                      {!isCollapsed && (
                        <div className="flex items-center gap-2">
                          <span className="text-sm">{item.label}</span>
                          {item.isNew && (
                            <span className="bg-green-500/30 text-green-500 text-[10px] font-bold px-1.5 py-0.5 rounded flex items-center gap-1 animate-pulse">
                              <span className="w-1 h-1 bg-green-200 rounded-full"></span>
                              YENİ
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                    {!isCollapsed && <i className={`pi pi-chevron-right text-[10px] transition-transform duration-200 ${isOpen ? "rotate-90" : ""}`} />}
                  </button>
                ) : (
                  <Link
                    to={item.link}
                    className={`w-full flex items-center ${isCollapsed ? "justify-center" : "justify-between"} px-3.5 py-2.5 rounded-xl transition-all duration-200 bg-transparent group-hover:bg-slate-800/50 border-none cursor-pointer no-underline ${isActive ? "bg-blue-600/10 text-blue-500 font-semibold" : "text-slate-400 font-medium hover:text-slate-200"
                      }`}
                    onClick={onClose}
                    title={isCollapsed ? item.label : ""}
                  >
                    <div className="flex items-center gap-2.5">
                      <div className="relative">
                        <i className={`${item.icon} text-lg ${isActive ? "text-blue-500" : "text-slate-500 group-hover:text-slate-300"}`} />
                        {isCollapsed && item.isNew && (
                          <span className="absolute -top-1 -right-1 flex h-2 w-2">
                            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                            <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
                          </span>
                        )}
                      </div>
                      {!isCollapsed && (
                        <div className="flex items-center gap-2">
                          <span className="text-sm">{item.label}</span>
                          {item.isNew && (
                            <span className="bg-green-500/30 text-green-500 text-[10px] font-bold px-1.5 py-0.5 rounded flex items-center gap-1 animate-pulse">
                              <span className="w-1 h-1 bg-green-200 rounded-full"></span>
                              YENİ
                            </span>
                          )}
                        </div>
                      )}
                    </div>
                  </Link>
                )}

                {/* Floating Submenu for Collapsed Mode */}
                {isCollapsed && item.children && hoveredIndex === i && (
                  <div
                    className="fixed z-[9999] pointer-events-auto"
                    style={{
                      left: '80px',
                      top: `${hoverPos}px`,
                      width: '240px',
                      paddingLeft: '8px'
                    }}
                    onMouseEnter={() => handleMouseEnter(i)}
                    onMouseLeave={handleMouseLeave}
                  >
                    <div className="bg-[#1e293b] border border-slate-700 rounded-2xl shadow-[0_20px_50px_rgba(0,0,0,0.5)] overflow-hidden">
                      <div className="py-3 px-4 border-b border-slate-700/50 bg-slate-800/50">
                        <span className="text-xs font-black text-white uppercase tracking-widest">{item.label}</span>
                      </div>
                      <div className="p-1.5 space-y-0.5">
                        {item.children.map((child, j) => {
                          const isChildActive = location.pathname === child.link;
                          return (
                            <Link
                              key={j}
                              to={child.link}
                              className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-[13px] transition-all duration-200 no-underline border-none cursor-pointer ${isChildActive
                                  ? "bg-blue-600/10 text-blue-500 font-semibold"
                                  : "text-slate-400 hover:bg-slate-800/50 hover:text-slate-200"
                                }`}
                              onClick={() => {
                                onClose();
                                setHoveredIndex(null);
                              }}
                            >
                              <i className={`${child.icon} text-[14px] ${isChildActive ? "text-blue-500" : "text-slate-500"}`} />
                              <div className="flex items-center gap-2">
                                <span>{child.label}</span>
                                {child.isNew && (
                                  <span className="bg-green-500/10 text-green-500 text-[9px] font-bold px-1 py-0.5 rounded animate-pulse">
                                    YENİ
                                  </span>
                                )}
                              </div>
                            </Link>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                )}

                {/* Alt menü */}
                {item.children && !isCollapsed && (
                  <div className={`overflow-hidden transition-all duration-300 ${isOpen ? "max-h-[500px] mt-0.5 opacity-100" : "max-h-0 opacity-0"}`}>
                    <div className="ml-9 space-y-0.5 border-l border-slate-800">
                      {item.children.map((child, j) => {
                        const isChildActive = location.pathname === child.link;
                        return (
                          <Link
                            key={j}
                            to={child.link}
                            className={`w-full flex items-center gap-2.5 px-3 py-2 rounded-lg text-[13px] transition-all duration-200 bg-transparent border-none cursor-pointer no-underline ${isChildActive
                                ? "text-blue-500 font-semibold"
                                : "text-slate-500 hover:text-slate-200 hover:translate-x-1"
                              }`}
                            onClick={onClose}
                          >
                            <i className={`${child.icon} text-[14px]`} />
                            <div className="flex items-center gap-2">
                              <span>{child.label}</span>
                              {child.isNew && (
                                <span className="bg-green-500/10 text-green-500 text-[9px] font-bold px-1 py-0.5 rounded animate-pulse">
                                  YENİ
                                </span>
                              )}
                            </div>
                          </Link>
                        );
                      })}
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </nav>
      </div>

      {/* FOOTER / ALT BÖLÜM */}
      <div className="p-4 border-t border-slate-800/50 bg-slate-900/50">
        <div className={`bg-slate-800/50 rounded-2xl ${isCollapsed ? "p-2" : "p-4"} flex items-center ${isCollapsed ? "justify-center" : "gap-4"}`}>
          <div className="w-10 h-10 min-w-10 rounded-full bg-blue-600/20 flex items-center justify-center text-blue-500">
            <i className="pi pi-question-circle text-lg" />
          </div>
          {!isCollapsed && (
            <div className="flex flex-col">
              <span className="text-xs font-bold text-white uppercase tracking-wider">Yardım Merkezi</span>
              <span className="text-[10px] text-slate-500">Desteğe mi ihtiyacın var?</span>
            </div>
          )}
        </div>
      </div>
    </aside>
  );
}